@if (daysLeft) {
  <div class="pwd-expiry-overlay d-flex align-items-center justify-content-center">
    <div class="pwd-expiry-modal bg-white radius-16 p-4">
      <h2 class="fs-20 fw-600 mb-2">Password Expiring Soon</h2>
      <p class="fs-14 fw-400 text-greyish mb-4">
        Your password will expire in {{ daysLeft }} {{ daysLeft === 1 ? 'day' : 'days' }}. Please update it to avoid losing access to your account.
      </p>
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-outline-secondary fs-14 fw-600" (click)="remindLater()">Remind Me Later</button>
        <button type="button" class="btn btn-primary fs-14 fw-600" (click)="changePasswordNow()">Change Password</button>
      </div>
    </div>
  </div>
}
